'use client';

import { useEffect, useRef } from 'react';
import { gtagEvent } from '@/components/GoogleAnalytics';

interface TrackerProduct {
  reference: string;
  name: string;
  manufacturer_name?: string;
  category_name?: string;
  price: number;
}

interface ViewItemListTrackerProps {
  listId: string;
  listName: string;
  products: TrackerProduct[];
  trackingKey: string; // unique key to prevent re-firing (e.g. search query)
}

export function ViewItemListTracker({ listId, listName, products, trackingKey }: ViewItemListTrackerProps) {
  const firedRef = useRef<string>('');

  useEffect(() => {
    if (products.length === 0) return;
    if (firedRef.current === trackingKey) return;
    firedRef.current = trackingKey;

    gtagEvent('view_item_list', {
      item_list_id: listId,
      item_list_name: listName,
      items: products.slice(0, 20).map((p, i) => ({
        item_id: p.reference,
        item_name: p.name,
        ...(p.manufacturer_name && { item_brand: p.manufacturer_name }),
        ...(p.category_name && { item_category: p.category_name }),
        index: i,
        price: p.price,
      })),
    });
  }, [products, trackingKey, listId, listName]);

  return null;
}
